// extracted by mini-css-extract-plugin
export default {"melodyVideo":"kJ-z","isFullWidth":"lJ-z","landingPageVideo":"mJ-z","play":"nJ-z","iframeVideo":"oJ-z","playHidden":"pJ-z","fullwidth":"qJ-z"};